// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-formstyleForm-select-bzucv{border-color:#eaedef;border-radius:0;cursor:pointer;height:44px;padding:0 16px;width:100%}.assets-scss-formstyleForm-select-bzucv,.assets-scss-formstyleForm-select-bzucv:hover{outline:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": "assets-scss-formstyleForm-select-bzucv"
};
module.exports = ___CSS_LOADER_EXPORT___;
